import { render, staticRenderFns } from "./ChargebackPriceConfigList.vue?vue&type=template&id=2493a1b0&scoped=true&"
import script from "./ChargebackPriceConfigList.vue?vue&type=script&lang=js&"
export * from "./ChargebackPriceConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackPriceConfigList.vue?vue&type=style&index=0&id=2493a1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493a1b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
